
export async function showFlagByIp() {
  const defaultSrc = 'es.png';
  const flags = {
    ES: 'es.png',
    MX: 'mx.png',
    AR: 'ar.png',
  };

  try {
    const res = await fetch('https://ipapi.co/json/');
    const data = await res.json();
    const countryKey = data.country || 'ES';
    const src = flags[countryKey] || defaultSrc;

    return src;
  } catch (error) {
    console.error('Error al obtener IP:', error);
    return defaultSrc;
  }
}

